import ChipRow from '../../../components/ChipRow'
import type { ChipStatus } from '../../../chipStatus'
import { chipDefinitions } from '../../../mockChips'
import type { ChipId } from '../../../types'
import DemoFrame from './DemoFrame'
import { demoNoop } from './demoFixtures'

/**
 * Availability is the rule, not the effect. The row is frozen with two chips
 * available and one spent, because the states sitting side by side are what teach it — what each
 * chip *does* is the copy's job, and the caps live in the section's `points`.
 */
const DEMO_STATUS: Record<ChipId, ChipStatus> = {
  doubleUp: 'available',
  goalfest: 'available',
  cleanSweep: 'used',
}

export default function ChipsDemo() {
  return (
    <DemoFrame className="rules-demo--chips">
      <ChipRow
        chips={chipDefinitions}
        getStatus={(chipId) => DEMO_STATUS[chipId]}
        onSelectChip={demoNoop}
      />
    </DemoFrame>
  )
}
